import { createRoute } from '@tanstack/react-router';
import { InboundPage } from '@/features/stock/InboundPage';
import { Route as shellRoute } from '../_shell';

/** Purchase orders, reorder suggestions and the supplier scorecard, on one screen. */
export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/stock/inbound',
  component: InboundPage,
});
